import React, { useEffect, useLayoutEffect, useState } from "react";
import Title from "../../../Common/Title";
import img1 from "../../../../Assets/Images/03-icon-1@3x.png";
import img2 from "../../../../Assets/Images/03-icon-2@3x.png";
import img3 from "../../../../Assets/Images/03-icon-3@3x.png";
import img4 from "../../../../Assets/Images/03-icon-4@3x.png";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./styles.scss";
import Button from "../../../Common/Button";
import { useNavigate } from "react-router-dom";
import { RoutesString } from "../../../Modules/routesString";
import { Power4 } from "gsap/all";
import * as Scroll from "react-scroll"


gsap.registerPlugin(ScrollTrigger);

function Service() {
  const scroll = Scroll.animateScroll
  const navigation = useNavigate()
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }
  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);
  
  const isTable = width <= 1280;

  //animation
  useLayoutEffect(() => {
    if(isTable) return
    let ctx = gsap.context(() => {
      let timeline = gsap.timeline({
        scrollTrigger: {
          trigger: `.service-container`,
          start: "top center",
        },
      });

      timeline.from(`.service-list`, {
        x: 1030,
        duration: 2,
        autoAlpha: 0,
        ease: Power4.easeOut,
        // delay: 1
      });
    });

    return () => ctx.revert();
  }, [isTable]);
  return (
    <div id="homeService" className="service">
      <div className="service-container">
        <Title
          title={
            <div>
              <span>CSbye</span> Service
            </div>
          }
          detail={`ADD-UP（股份）有限公司是拥有顾客管理服务经验的企业,
          
          提供客户运营管理(CS)服务、QA(质量保证)、营销、监控等以广泛领域的服务实现客户满意度的运营管理服务公司。`}
        />

        <ul className="service-list">
          {data.map((item, index) => (
            <li key={index} className="service-item">
              <div className="service-item-img">
                <img src={item.img} alt="" />
                <div className="content">
                  <div className="content-title">{item.title}</div>
                  <div className="content-detail">
                    <p>{item.detail1}</p>
                    <p>{item.detail2}</p>
                    <p>{item.detail3}</p>
                    <p>{item.detail4}</p>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
    
        <div className="service-button">
          <Button rightIcon onClick={() => {
                  scroll.scrollToTop()
            navigation(RoutesString.Intro_cn);
          }} text="查看更多" size="normal" />
        </div>
      </div>
    </div>
  );
}

export default Service;

const data = [
  {
    img: img1,
    title: "客户运营管理服务",
    detail1: "· 市场与社区",
    detail2: "· 通过VOC（统计）报告建议服务方向",
    detail3: "· 咨询受理、结算及退款管理",
    detail4: "· VIP优先应对及服务提供",
  },
  {
    img: img2,
    title: "质量保证QA",
    detail1: "· 应用程序和网络功能测试",
    detail2: "· 终端兼容性测试",
    detail3: "· 更新维护测试",
    detail4: "· 其他质量保证测试",
  },
  {
    img: img3,
    title: "营销服务",
    detail1: "· SNS发布及营销工作",
    detail2: "· 活动策划和CS管理",
    detail3: "· 制作多种病毒视频",
    detail4: "· 活动结果传达及奖品发送业务",
  },
  {
    img: img4,
    title: "24小时密切监控",
    detail1: "· 24小时实时响应",
    detail2: "· 市场评论应对",
    detail3: "· 出现故障时及时响应",
    detail4: "· 每小时提供报告",
  },
];
